import PropTypes from "prop-types";
import { Tabs, Tab, Tooltip, Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useICCCColors } from "../components/theme";

export default function MapTopBar({ locations, selectedLocationId, onSelectLocation }) {
  const ICCC_COLORS = useICCCColors();

  if (!locations.length) return null;

  return (
    <MDBox
      sx={{
        bgcolor: ICCC_COLORS.cardBg,
        border: `1px solid ${ICCC_COLORS.cardBorder}`,
        borderRadius: 1.5,
        px: 1,
        display: "flex",
        alignItems: "center",
        boxShadow: ICCC_COLORS.shadow,
      }}
    >
      <Icon sx={{ color: ICCC_COLORS.accent, mr: 1 }}>explore</Icon>
      <Tabs
        value={selectedLocationId ?? false}
        onChange={(_, id) => onSelectLocation(id)}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{
          minHeight: 44,
          flex: 1,
          "& .MuiTab-root": {
            minHeight: 44,
            textTransform: "none",
            color: ICCC_COLORS.textSecondary,
            maxWidth: 220,
          },
          "& .MuiTab-root.Mui-selected": { color: ICCC_COLORS.accent, fontWeight: 700 },
          "& .MuiTabs-indicator": { backgroundColor: ICCC_COLORS.accent },
        }}
      >
        {locations.map((loc) => (
          <Tab
            key={loc.id}
            value={loc.id}
            label={
              <Tooltip title={loc.parentLocationName ? `${loc.parentLocationName} / ${loc.name}` : loc.name}>
                <MDTypography
                  variant="button"
                  fontWeight={loc.id === selectedLocationId ? "bold" : "regular"}
                  sx={{
                    color: "inherit",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "block",
                    maxWidth: 200,
                  }}
                >
                  {loc.name}
                </MDTypography>
              </Tooltip>
            }
          />
        ))}
      </Tabs>
    </MDBox>
  );
}

MapTopBar.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedLocationId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onSelectLocation: PropTypes.func.isRequired,
};
